import { render, staticRenderFns } from "./MedicalStaff.vue?vue&type=template&id=46590b85&scoped=true&"
import script from "./MedicalStaff.vue?vue&type=script&lang=js&"
export * from "./MedicalStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46590b85",
  null
  
)

export default component.exports